// Conteúdo da landing page do TUTO — cópia centralizada para edição fácil.
// Cópia honesta: produto entrega e-mail (sem WhatsApp), intimações automáticas
// A cobertura é nacional e inclui todos os tribunais. A cópia afirma o que é
// coberto, sem detalhar de qual fonte o dado vem — isso é implementação.

import { FileText, Bell, Calendar, Shield, Users, Scale, SquareKanban, Send, Contact, Wallet, Bot, FileSignature, Banknote } from "lucide-react";

export const hero = {
  eyebrow: "Cobertura nacional de todos os tribunais · by KOSMOS",
  h1: "Nunca mais perca um prazo.",
  subH1: "Suas intimações do DJEN, lidas e organizadas — automaticamente.",
  subtitle:
    "Feito para o advogado autônomo e o escritório iniciante. Sem planilha, sem secretária conferindo o Diário, sem complexidade.",
  ctaPrimary: "Começar agora",
  ctaSecondary: "Já tenho conta",
  // O preço vem de /api/plans, nunca daqui. Enquanto não chega, a frase sai
  // sem ele: uma promessa a menos é melhor que um valor que não é o cobrado.
  microcopy: "cancele quando quiser • configure em 2 minutos",
  microcopyComPreco: "{preco}/mês • cancele quando quiser • configure em 2 minutos",
};

// StatsBand — números são dados reais do negócio; preencher quando disponíveis.
export const statsBand = [
  // TODO: número real
  { value: null, label: "processos monitorados" },
  // TODO: número real
  { value: null, label: "intimações lidas automaticamente" },
  // TODO: número real
  { value: null, label: "advogados usando o Tuto" },
];

// Tecnologias e parcerias — logo wall (grayscale). Arquivos em public/partners/.
// Imagens ausentes são ocultadas automaticamente (onError) até serem adicionadas.
export const partners = [
  { src: "/partners/microsoft-startups.png", alt: "Microsoft for Startups" },
  { src: "/partners/anthropic.svg", alt: "Anthropic" },
  { src: "/partners/mongodb.svg", alt: "MongoDB" },
  { src: "/partners/newrelic.svg", alt: "New Relic" },
  { src: "/partners/sqlserver.svg", alt: "SQL Server" },
  { src: "/partners/sebrae.png", alt: "Sebrae SP" },
  { src: "/partners/kosmos.png", alt: "Kosmos", dark: true },
  // Imagem tem margem transparente — escala pra preencher melhor o card.
  { src: "/partners/intellitouch.png", alt: "Intellitouch", dark: true, imgClass: "scale-[1.7]" },
];

export const howItWorks = {
  title: "Comece em 3 passos",
  steps: [
    {
      n: 1,
      title: "Cadastre sua OAB",
      desc: "Em segundos, sem instalar nada.",
    },
    {
      n: 2,
      title: "O Tuto monitora o DJEN",
      desc: "Lê o Diário todos os dias e identifica as publicações das suas OABs cadastradas.",
    },
    {
      n: 3,
      title: "Intimações viram tarefas",
      desc: "Cada publicação chega lida e classificada — você não perde nenhuma intimação.",
    },
  ],
  cta: "Começar agora",
};

// Carrossel — usar screenshots reais (WebP, dados mascarados/LGPD) quando disponíveis.
// src=null renderiza moldura placeholder. // TODO: trocar por assets reais.
// IMPORTANTE: usar prints com DADOS MASCARADOS (LGPD) — sem nomes/CNJ/e-mail/convite reais.
// Arquivos em public/landing/. Enquanto não existirem, o carrossel mostra placeholder.
export const carouselSlides = [
  {
    id: "dashboard",
    src: "/landing/dashboard.png",
    alt: "Dashboard do TUTO com processos, intimações, prazos e gráficos",
    caption: "Seu painel: processos, intimações, prazos e gráficos num só lugar.",
  },
  {
    id: "intimacoes",
    src: "/landing/intimacoes.png",
    alt: "Painel de Intimações do TUTO com publicações do DJEN classificadas",
    caption: "Intimações do DJEN lidas e classificadas automaticamente.",
  },
  {
    id: "processos",
    src: "/landing/processos.png",
    alt: "Painel de Processos do TUTO com processos de todos os tribunais",
    caption: "Todos os seus processos, de qualquer tribunal, sincronizados.",
  },
  {
    id: "agenda",
    src: "/landing/agenda.png",
    alt: "Agenda jurídica do TUTO com prazos no calendário",
    caption: "Cada prazo já na sua agenda — sem você lembrar.",
  },
  {
    id: "configuracoes",
    src: "/landing/configuracoes.png",
    alt: "Configurações do escritório no TUTO: OABs, equipe e notificações",
    caption: "Cadastre suas OABs e configure os alertas do escritório.",
  },
];

export const features = [
  {
    icon: FileText,
    title: "Painel de Processos",
    desc: "Cadastre pelo número CNJ e o Tuto sincroniza os andamentos, seja qual for o tribunal. Histórico sempre atualizado.",
  },
  {
    icon: Bell,
    title: "Painel de Intimações",
    desc: "O Tuto lê o DJEN por você todos os dias e classifica cada publicação das suas OABs.",
  },
  {
    icon: Calendar,
    title: "Agenda Jurídica",
    desc: "Todo prazo cai na agenda automaticamente. Nada depende de você lembrar.",
  },
  {
    icon: Shield,
    title: "Cobertura nacional de todos os tribunais",
    desc: "Justiça estadual, federal e do trabalho, em todo o país. Não importa qual sistema o tribunal usa — e você não cadastra credencial de nenhum.",
  },
  {
    icon: Scale,
    title: "Pesquisa de jurisprudências",
    desc: "Pesquise decisões judiciais por tema, tese, tribunal ou expressão jurídica.",
  },
  {
    icon: FileText,
    title: "Notas por processo",
    desc: "Centralize anotações e o contexto de cada caso num só lugar.",
  },
  {
    icon: Users,
    title: "Multi-usuário",
    desc: "Cresceu? Some sua equipe sem perder a organização. (PRO)",
  },
  {
    icon: SquareKanban,
    title: "Kanban de tarefas",
    desc: "Organize suas atividades em quadros com etapas e arraste os cards. Disponível no FREE e no PRO.",
  },
  {
    icon: Send,
    title: "Alertas via Telegram",
    desc: "Receba intimações e prazos direto no Telegram, além do email. Disponível no FREE e no PRO.",
  },
  {
    icon: Contact,
    title: "Clientes",
    desc: "Cadastre clientes e contatos, vincule aos processos e importe sua carteira. Dados protegidos conforme a LGPD.",
  },
  {
    icon: Wallet,
    title: "Finanças do escritório",
    desc: "Lançamentos de receitas e despesas, parcelas, baixas e resumo do mês. Exclusivo do PRO.",
  },
  {
    icon: Bot,
    title: "Assistente de IA",
    desc: "Pergunte sobre seus processos, intimações e prazos em linguagem natural. Funciona com a conta de IA que você já paga — o Tuto não cobra por mensagem. FREE e PRO.",
    badge: "Novo",
  },
  {
    icon: Calendar,
    title: "Prazo da intimação na agenda",
    desc: "Se você quiser, o modelo lê cada intimação nova, identifica o tipo do ato e lança o prazo na agenda para a sua conferência.",
    badge: "Novo",
  },
  {
    icon: FileSignature,
    title: "Documentos a partir dos seus modelos",
    desc: "Suba seus .docx com marcações de preenchimento e gere a peça com os dados do cliente e do processo já preenchidos.",
    badge: "Novo",
  },
  {
    icon: Banknote,
    title: "Cobrança por boleto, Pix e cartão",
    desc: "Conecte sua conta Asaas e cobre seus clientes a partir dos lançamentos. Quando o cliente paga, a parcela baixa sozinha. Exclusivo do PRO.",
    badge: "Novo",
  },
];

export const beforeAfter = {
  before: {
    title: "Sem o Tuto",
    items: [
      "Conferir o DJEN manualmente",
      "Controlar prazo em planilha",
      "Risco de perder publicação",
      "Descobrir tarde demais",
    ],
  },
  after: {
    title: "Com o Tuto",
    items: [
      "Intimação chega lida e classificada",
      "Publicações classificadas automaticamente",
      "Alerta por e-mail e Telegram",
      "Tudo na agenda",
    ],
  },
};

export const integrations = {
  title: "Cobertura nacional de todos os tribunais.",
  subtitle:
    "Seus processos acompanhados em qualquer tribunal do país, e suas intimações lidas todos os dias.",
  items: ["Justiça Estadual", "Justiça Federal", "Justiça do Trabalho", "Tribunais Superiores"],
};

// Depoimentos reais são dependência do negócio. NÃO fabricar.
// TODO: depoimento real { quote, nome, oab_ou_cidade, foto }
export const testimonials = [];

export const faq = [
  {
    q: "O Tuto é seguro? Meus dados estão protegidos?",
    a: "Sim. Seus dados são tratados conforme a LGPD e nunca compartilhados com terceiros.",
  },
  {
    q: "Preciso instalar alguma coisa?",
    a: "Não. O Tuto é 100% web — funciona no navegador, no computador ou no celular.",
  },
  {
    q: "Funciona com a minha OAB?",
    a: "Sim. Você cadastra sua OAB e o Tuto passa a monitorar o DJEN automaticamente para as suas publicações.",
  },
  {
    q: "O Tuto funciona com o tribunal onde eu atuo?",
    a: "Sim. A cobertura é nacional e inclui todos os tribunais — justiça estadual, federal e do trabalho, além dos tribunais superiores. Não importa qual sistema o seu tribunal usa, e você não precisa cadastrar senha nem credencial de nenhum deles.",
  },
  {
    q: "Quanto custa o TUTO?",
    a: "O START é cobrado por mês, com cancelamento a qualquer momento e sem multa. Quem já usava o plano gratuito continua nele, sem mudança.",
    aComPreco: "O START custa {preco} por mês, com cancelamento a qualquer momento e sem multa. Quem já usava o plano gratuito continua nele, sem mudança.",
  },
  {
    q: "Como o Tuto lê minhas intimações?",
    a: "Ele consulta o DJEN diariamente e classifica cada publicação das suas OABs, organizando tudo num só lugar.",
  },
  {
    q: "Posso cancelar quando quiser?",
    a: "Sim, a qualquer momento, sem multa.",
  },
  {
    q: "Quanto tempo leva para configurar?",
    a: "Minutos. Você cadastra a OAB e o sistema começa a monitorar.",
  },
  {
    q: "Vou receber notificação demais?",
    a: "Não. Você controla o que e como quer ser avisado.",
  },
  {
    q: "O Tuto tem inteligência artificial? Está incluída no plano?",
    a: "O assistente está no FREE e no PRO, e o Tuto não cobra por mensagem. Ele funciona com a conta de IA do seu escritório: você conecta a conta que já paga — Anthropic, OpenAI, Gemini, OpenRouter, NVIDIA ou um endpoint próprio — e o consumo é cobrado no seu provedor. Dentro do Tuto há um extrato mostrando quanto foi usado.",
  },
  {
    q: "A IA pode lançar meus prazos na agenda?",
    a: "Pode, se você ligar essa opção. O modelo lê cada intimação nova, identifica o tipo do ato e lança o prazo ou a audiência na agenda, marcado como estimativa da IA — a conferência no processo continua sendo sua.",
  },
  {
    q: "Meus dados vão para o modelo de IA?",
    a: "Só o necessário para responder à sua pergunta, e CPF e CNPJ vão mascarados: o número completo não é enviado ao provedor.",
  },
  {
    q: "Dá para gerar peças a partir dos meus próprios modelos?",
    a: "Sim. Você sobe seus arquivos .docx com marcações de preenchimento e o Tuto completa com os dados do cliente, do processo e do escritório, pedindo só o que falta. O FREE inclui 5 modelos e 10 documentos; o PRO é ilimitado.",
  },
];

export const finalCta = {
  title: "Pronto para parar de perder prazo?",
  cta: "Assinar agora",
  ctaComPreco: "Assinar por {preco}",
  microcopy: "cancele quando quiser • configure em 2 minutos",
};

export const pricing = {
  // Reserva apenas para o que não é preço. Nome, recursos e textos de botão
  // podem ser mostrados antes de /api/plans responder; valor, não.
  free: {
    name: "START",
    period: "/mês",
    features: [
      "Até 100 processos",
      "2 usuários",
      "1 OAB cadastrada",
      "Painel de processos",
      "Painel de intimações",
      "Agenda jurídica",
      "5 pesquisas de jurisprudências (total)",
    ],
    cta: "Assinar START",
    microcopy: "cancele quando quiser",
  },
  pro: {
    name: "PRO",
    period: "/mês",
    features: [
      "Processos ilimitados",
      "Usuários ilimitados",
      "Até 10 OABs cadastradas",
      "Sincronização diária automática",
      "Notas por processo",
      "Suporte prioritário",
      "50 pesquisas de jurisprudências por mês",
      "Finanças do escritório",
    ],
    cta: "Criar conta e assinar",
    microcopy: "cancele quando quiser",
  },
};
